module.exports = __webpack_public_path__ + "img/MEDIA115.3f18c321.jpg";